// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ValueOf} from '@fluxer/constants/src/ValueOf';

export const APIErrorCodes = {
	ACCESS_DENIED: 'ACCESS_DENIED',
	ANNOUNCEMENT_CHANNEL_REQUIRED: 'ANNOUNCEMENT_CHANNEL_REQUIRED',
	BAD_GATEWAY: 'BAD_GATEWAY',
	BAD_REQUEST: 'BAD_REQUEST',
	BLUESKY_OAUTH_AUTHORIZATION_FAILED: 'BLUESKY_OAUTH_AUTHORIZATION_FAILED',
	BLUESKY_OAUTH_NOT_ENABLED: 'BLUESKY_OAUTH_NOT_ENABLED',
	ACCOUNT_LIMITED: 'ACCOUNT_LIMITED',
	ACCOUNT_IDENTITY_LOCKED: 'ACCOUNT_IDENTITY_LOCKED',
	ACCOUNT_SUSPENDED_PERMANENTLY: 'ACCOUNT_SUSPENDED_PERMANENTLY',
	ACCOUNT_SUSPENDED_TEMPORARILY: 'ACCOUNT_SUSPENDED_TEMPORARILY',
	ACCOUNT_TOO_NEW_FOR_GUILD: 'ACCOUNT_TOO_NEW_FOR_GUILD',
	ACLS_MUST_BE_NON_EMPTY: 'ACLS_MUST_BE_NON_EMPTY',
	ADMIN_API_KEY_NOT_FOUND: 'ADMIN_API_KEY_NOT_FOUND',
	APPLICATION_NOT_OWNED: 'APPLICATION_NOT_OWNED',
	ALREADY_FRIENDS: 'ALREADY_FRIENDS',
	BOTS_CANNOT_CREATE_GUILDS: 'BOTS_CANNOT_CREATE_GUILDS',
	BOTS_CANNOT_SEND_FRIEND_REQUESTS: 'BOTS_CANNOT_SEND_FRIEND_REQUESTS',
	BOT_ALREADY_IN_GUILD: 'BOT_ALREADY_IN_GUILD',
	BOT_IS_PRIVATE: 'BOT_IS_PRIVATE',
	BOT_USER_AUTH_ENDPOINT_ACCESS_DENIED: 'BOT_USER_AUTH_ENDPOINT_ACCESS_DENIED',
	BOT_USER_AUTH_SESSION_CREATION_DENIED: 'BOT_USER_AUTH_SESSION_CREATION_DENIED',
	BOT_USER_GENERATION_FAILED: 'BOT_USER_GENERATION_FAILED',
	BOT_USER_NOT_FOUND: 'BOT_USER_NOT_FOUND',
	CALL_ALREADY_EXISTS: 'CALL_ALREADY_EXISTS',
	CANNOT_EDIT_OTHER_USER_MESSAGE: 'CANNOT_EDIT_OTHER_USER_MESSAGE',
	CANNOT_EXECUTE_ON_DM: 'CANNOT_EXECUTE_ON_DM',
	CANNOT_BLOCK_SYSTEM_USER: 'CANNOT_BLOCK_SYSTEM_USER',
	CANNOT_MODIFY_SYSTEM_WEBHOOK: 'CANNOT_MODIFY_SYSTEM_WEBHOOK',
	CANNOT_REDEEM_PLUTONIUM_WITH_VISIONARY: 'CANNOT_REDEEM_PLUTONIUM_WITH_VISIONARY',
	CANNOT_REPORT_GUILD: 'CANNOT_REPORT_GUILD',
	CANNOT_REPORT_OWN_GUILD: 'CANNOT_REPORT_OWN_GUILD',
	CANNOT_REPORT_OWN_MESSAGE: 'CANNOT_REPORT_OWN_MESSAGE',
	CANNOT_REPORT_YOURSELF: 'CANNOT_REPORT_YOURSELF',
	CANNOT_SEND_EMPTY_MESSAGE: 'CANNOT_SEND_EMPTY_MESSAGE',
	CANNOT_SEND_FRIEND_REQUEST_TO_BLOCKED_USER: 'CANNOT_SEND_FRIEND_REQUEST_TO_BLOCKED_USER',
	CANNOT_SEND_FRIEND_REQUEST_TO_SELF: 'CANNOT_SEND_FRIEND_REQUEST_TO_SELF',
	CANNOT_SEND_MESSAGES_IN_NON_TEXT_CHANNEL: 'CANNOT_SEND_MESSAGES_IN_NON_TEXT_CHANNEL',
	CANNOT_SEND_MESSAGES_TO_USER: 'CANNOT_SEND_MESSAGES_TO_USER',
	CANNOT_TRANSFER_OWNERSHIP_TO_BOT: 'CANNOT_TRANSFER_OWNERSHIP_TO_BOT',
	CAPTCHA_REQUIRED: 'CAPTCHA_REQUIRED',
	CHANNEL_ALREADY_FOLLOWED: 'CHANNEL_ALREADY_FOLLOWED',
	CHANNEL_HAS_FOLLOWED_CHANNELS: 'CHANNEL_HAS_FOLLOWED_CHANNELS',
	CHANNEL_HAS_THREADS: 'CHANNEL_HAS_THREADS',
	CHANNEL_TYPE_CONVERSION_NOT_SUPPORTED: 'CHANNEL_TYPE_CONVERSION_NOT_SUPPORTED',
	COMMUNICATION_DISABLED: 'COMMUNICATION_DISABLED',
	CONNECTION_ALREADY_EXISTS: 'CONNECTION_ALREADY_EXISTS',
	CONNECTION_INITIATION_TOKEN_INVALID: 'CONNECTION_INITIATION_TOKEN_INVALID',
	CONNECTION_INVALID_TYPE: 'CONNECTION_INVALID_TYPE',
	CONNECTION_LIMIT_REACHED: 'CONNECTION_LIMIT_REACHED',
	CONNECTION_NOT_FOUND: 'CONNECTION_NOT_FOUND',
	CONNECTION_VERIFICATION_FAILED: 'CONNECTION_VERIFICATION_FAILED',
	CONFLICT: 'CONFLICT',
	CONTENT_BLOCKED: 'CONTENT_BLOCKED',
	DELETION_FAILED: 'DELETION_FAILED',
	DISCOVERY_ALREADY_APPLIED: 'DISCOVERY_ALREADY_APPLIED',
	DISCOVERY_APPLICATION_ALREADY_REVIEWED: 'DISCOVERY_APPLICATION_ALREADY_REVIEWED',
	DISCOVERY_APPLICATION_NOT_FOUND: 'DISCOVERY_APPLICATION_NOT_FOUND',
	DISCOVERY_DISABLED: 'DISCOVERY_DISABLED',
	DISCOVERY_INSUFFICIENT_MEMBERS: 'DISCOVERY_INSUFFICIENT_MEMBERS',
	DISCOVERY_NOT_DISCOVERABLE: 'DISCOVERY_NOT_DISCOVERABLE',
	DISCRIMINATOR_REQUIRED: 'DISCRIMINATOR_REQUIRED',
	EMAIL_SERVICE_NOT_TESTABLE: 'EMAIL_SERVICE_NOT_TESTABLE',
	EMAIL_UNAVAILABLE_ON_INSTANCE: 'EMAIL_UNAVAILABLE_ON_INSTANCE',
	EMAIL_VERIFICATION_REQUIRED: 'EMAIL_VERIFICATION_REQUIRED',
	DIRECT_MESSAGE_EMAIL_VERIFICATION_REQUIRED: 'DIRECT_MESSAGE_EMAIL_VERIFICATION_REQUIRED',
	FOLLOW_TARGET_CONTENT_WARNING_REQUIRED: 'FOLLOW_TARGET_CONTENT_WARNING_REQUIRED',
	FOLLOW_TARGET_NOT_AGE_RESTRICTED: 'FOLLOW_TARGET_NOT_AGE_RESTRICTED',
	FRIEND_REQUEST_EMAIL_VERIFICATION_REQUIRED: 'FRIEND_REQUEST_EMAIL_VERIFICATION_REQUIRED',
	GUILD_CREATION_EMAIL_VERIFICATION_REQUIRED: 'GUILD_CREATION_EMAIL_VERIFICATION_REQUIRED',
	GUILD_CREATION_PERMISSION_REQUIRED: 'GUILD_CREATION_PERMISSION_REQUIRED',
	GUILD_EMAIL_VERIFICATION_REQUIRED: 'GUILD_EMAIL_VERIFICATION_REQUIRED',
	INVALID_FOLLOW_TARGET_CHANNEL: 'INVALID_FOLLOW_TARGET_CHANNEL',
	MESSAGE_ALREADY_CROSSPOSTED: 'MESSAGE_ALREADY_CROSSPOSTED',
	MESSAGE_CROSSPOST_RATE_LIMITED: 'MESSAGE_CROSSPOST_RATE_LIMITED',
	MESSAGE_NOT_CROSSPOSTABLE: 'MESSAGE_NOT_CROSSPOSTABLE',
	MFA_EMAIL_VERIFICATION_REQUIRED: 'MFA_EMAIL_VERIFICATION_REQUIRED',
	PROFILE_EMAIL_VERIFICATION_REQUIRED: 'PROFILE_EMAIL_VERIFICATION_REQUIRED',
	PUBLISHED_MESSAGE_EDIT_RATE_LIMITED: 'PUBLISHED_MESSAGE_EDIT_RATE_LIMITED',
	PURCHASE_EMAIL_VERIFICATION_REQUIRED: 'PURCHASE_EMAIL_VERIFICATION_REQUIRED',
	REACTION_EMAIL_VERIFICATION_REQUIRED: 'REACTION_EMAIL_VERIFICATION_REQUIRED',
	REPORT_EMAIL_VERIFICATION_REQUIRED: 'REPORT_EMAIL_VERIFICATION_REQUIRED',
	REGISTRATION_CLOSED: 'REGISTRATION_CLOSED',
	REGISTRATION_PENDING_APPROVAL: 'REGISTRATION_PENDING_APPROVAL',
	REGISTRATION_REJECTED: 'REGISTRATION_REJECTED',
	REGISTRATION_URL_INVALID: 'REGISTRATION_URL_INVALID',
	EXPLICIT_CONTENT_CANNOT_BE_SENT: 'EXPLICIT_CONTENT_CANNOT_BE_SENT',
	FEATURE_NOT_AVAILABLE_SELF_HOSTED: 'FEATURE_NOT_AVAILABLE_SELF_HOSTED',
	FEATURE_TEMPORARILY_DISABLED: 'FEATURE_TEMPORARILY_DISABLED',
	FILE_SIZE_TOO_LARGE: 'FILE_SIZE_TOO_LARGE',
	FORBIDDEN: 'FORBIDDEN',
	FORUM_TAG_NAMES_MUST_BE_UNIQUE: 'FORUM_TAG_NAMES_MUST_BE_UNIQUE',
	FORUM_TAG_REQUIRED: 'FORUM_TAG_REQUIRED',
	FRIEND_REQUEST_BLOCKED: 'FRIEND_REQUEST_BLOCKED',
	GATEWAY_TIMEOUT: 'GATEWAY_TIMEOUT',
	GENERAL_ERROR: 'GENERAL_ERROR',
	GONE: 'GONE',
	GIFT_CODE_ALREADY_REDEEMED: 'GIFT_CODE_ALREADY_REDEEMED',
	GUILD_TEMPLATE_INVALID: 'GUILD_TEMPLATE_INVALID',
	GUILD_VERIFICATION_REQUIRED: 'GUILD_VERIFICATION_REQUIRED',
	HANDOFF_CODE_EXPIRED: 'HANDOFF_CODE_EXPIRED',
	HARVEST_EXPIRED: 'HARVEST_EXPIRED',
	HARVEST_FAILED: 'HARVEST_FAILED',
	HARVEST_NOT_READY: 'HARVEST_NOT_READY',
	HIDE_MEDIA_DOWNLOAD_OPTION_MEDIA_ONLY: 'HIDE_MEDIA_DOWNLOAD_OPTION_MEDIA_ONLY',
	INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
	INVALID_ACLS_FORMAT: 'INVALID_ACLS_FORMAT',
	INVALID_API_ORIGIN: 'INVALID_API_ORIGIN',
	INVALID_AUTH_TOKEN: 'INVALID_AUTH_TOKEN',
	INVALID_BOT_FLAG: 'INVALID_BOT_FLAG',
	INVALID_CAPTCHA: 'INVALID_CAPTCHA',
	INVALID_CHANNEL_TYPE_FOR_CALL: 'INVALID_CHANNEL_TYPE_FOR_CALL',
	INVALID_CHANNEL_TYPE: 'INVALID_CHANNEL_TYPE',
	INVALID_DSA_REPORT_TARGET: 'INVALID_DSA_REPORT_TARGET',
	INVALID_DSA_TICKET: 'INVALID_DSA_TICKET',
	INVALID_DSA_VERIFICATION_CODE: 'INVALID_DSA_VERIFICATION_CODE',
	INVALID_FLAGS_FORMAT: 'INVALID_FLAGS_FORMAT',
	INVALID_FORM_BODY: 'INVALID_FORM_BODY',
	INVALID_HANDOFF_CODE: 'INVALID_HANDOFF_CODE',
	INVALID_ORIGIN_HANDOFF_NONCE: 'INVALID_ORIGIN_HANDOFF_NONCE',
	INVALID_PASSKEY_BRIDGE_NONCE: 'INVALID_PASSKEY_BRIDGE_NONCE',
	INVALID_PERMISSIONS_INTEGER: 'INVALID_PERMISSIONS_INTEGER',
	INVALID_PERMISSIONS_NEGATIVE: 'INVALID_PERMISSIONS_NEGATIVE',
	INVALID_REPORT_FLOW_ANSWERS: 'INVALID_REPORT_FLOW_ANSWERS',
	INVALID_REQUEST: 'INVALID_REQUEST',
	INVALID_STREAM_KEY_FORMAT: 'INVALID_STREAM_KEY_FORMAT',
	INVALID_STREAM_THUMBNAIL_PAYLOAD: 'INVALID_STREAM_THUMBNAIL_PAYLOAD',
	INVALID_SYSTEM_FLAG: 'INVALID_SYSTEM_FLAG',
	INVALID_TIMESTAMP: 'INVALID_TIMESTAMP',
	INVALID_TOKEN: 'INVALID_TOKEN',
	INVALID_THREAD_NOTIFICATION_SETTINGS: 'INVALID_THREAD_NOTIFICATION_SETTINGS',
	INVALID_WEBAUTHN_AUTHENTICATION_COUNTER: 'INVALID_WEBAUTHN_AUTHENTICATION_COUNTER',
	INVALID_WEBAUTHN_CREDENTIAL_COUNTER: 'INVALID_WEBAUTHN_CREDENTIAL_COUNTER',
	INVALID_WEBAUTHN_CREDENTIAL: 'INVALID_WEBAUTHN_CREDENTIAL',
	INVALID_WEBAUTHN_PUBLIC_KEY_FORMAT: 'INVALID_WEBAUTHN_PUBLIC_KEY_FORMAT',
	INVITES_DISABLED: 'INVITES_DISABLED',
	IP_AUTHORIZATION_REQUIRED: 'IP_AUTHORIZATION_REQUIRED',
	IP_AUTHORIZATION_RESEND_COOLDOWN: 'IP_AUTHORIZATION_RESEND_COOLDOWN',
	IP_AUTHORIZATION_RESEND_LIMIT_EXCEEDED: 'IP_AUTHORIZATION_RESEND_LIMIT_EXCEEDED',
	GLOBAL_IP_BANNED: 'GLOBAL_IP_BANNED',
	GLOBAL_IP_TEMPORARILY_BANNED: 'GLOBAL_IP_TEMPORARILY_BANNED',
	IP_BAN_DECLINED: 'IP_BAN_DECLINED',
	MAX_APPLICATIONS: 'MAX_APPLICATIONS',
	MAX_BOOKMARKS: 'MAX_BOOKMARKS',
	MAX_ACTIVE_THREADS: 'MAX_ACTIVE_THREADS',
	MAX_CATEGORY_CHANNELS: 'MAX_CATEGORY_CHANNELS',
	MAX_EMOJIS: 'MAX_EMOJIS',
	MAX_FAVORITE_MEMES: 'MAX_FAVORITE_MEMES',
	MAX_FRIENDS: 'MAX_FRIENDS',
	MAX_FORUM_TAGS: 'MAX_FORUM_TAGS',
	MAX_GROUP_DM_RECIPIENTS: 'MAX_GROUP_DM_RECIPIENTS',
	MAX_GROUP_DMS: 'MAX_GROUP_DMS',
	GROUP_DM_RECIPIENTS_NOT_ADDABLE: 'GROUP_DM_RECIPIENTS_NOT_ADDABLE',
	GROUP_DM_MATURE_CONTENT_INELIGIBLE: 'GROUP_DM_MATURE_CONTENT_INELIGIBLE',
	MAX_GUILD_CHANNELS: 'MAX_GUILD_CHANNELS',
	MAX_GUILD_MEMBERS: 'MAX_GUILD_MEMBERS',
	MAX_GUILD_ROLES: 'MAX_GUILD_ROLES',
	MAX_GUILDS: 'MAX_GUILDS',
	MAX_PINNED_THREADS_IN_FORUM: 'MAX_PINNED_THREADS_IN_FORUM',
	MAX_INVITES: 'MAX_INVITES',
	MAX_REACTIONS: 'MAX_REACTIONS',
	MAX_STICKERS: 'MAX_STICKERS',
	MAX_THREAD_MEMBERS: 'MAX_THREAD_MEMBERS',
	MAX_WEBHOOKS_PER_CHANNEL: 'MAX_WEBHOOKS_PER_CHANNEL',
	MAX_WEBHOOKS_PER_GUILD: 'MAX_WEBHOOKS_PER_GUILD',
	MEDIA_METADATA_ERROR: 'MEDIA_METADATA_ERROR',
	METHOD_NOT_ALLOWED: 'METHOD_NOT_ALLOWED',
	MISSING_ACCESS: 'MISSING_ACCESS',
	MISSING_ACL: 'MISSING_ACL',
	MISSING_AUTHORIZATION: 'MISSING_AUTHORIZATION',
	MISSING_OAUTH_SCOPE: 'MISSING_OAUTH_SCOPE',
	MISSING_PERMISSIONS: 'MISSING_PERMISSIONS',
	NO_ACTIVE_CALL: 'NO_ACTIVE_CALL',
	NO_ACTIVE_SUBSCRIPTION: 'NO_ACTIVE_SUBSCRIPTION',
	NO_TAGS_AVAILABLE_TO_NON_MODERATORS: 'NO_TAGS_AVAILABLE_TO_NON_MODERATORS',
	NOT_FOUND: 'NOT_FOUND',
	NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
	NO_PASSKEYS_REGISTERED: 'NO_PASSKEYS_REGISTERED',
	NO_PENDING_DELETION: 'NO_PENDING_DELETION',
	NO_USERS_WITH_FLUXERTAG_EXIST: 'NO_USERS_WITH_FLUXERTAG_EXIST',
	NOT_A_BOT_APPLICATION: 'NOT_A_BOT_APPLICATION',
	NOT_FRIENDS_WITH_USER: 'NOT_FRIENDS_WITH_USER',
	NSFW_CONTENT_AGE_RESTRICTED: 'NSFW_CONTENT_AGE_RESTRICTED',
	PASSKEY_AUTHENTICATION_FAILED: 'PASSKEY_AUTHENTICATION_FAILED',
	PREMIUM_PURCHASE_BLOCKED: 'PREMIUM_PURCHASE_BLOCKED',
	PREVIEW_MUST_BE_JPEG: 'PREVIEW_MUST_BE_JPEG',
	PROCESSING_FAILED: 'PROCESSING_FAILED',
	RATE_LIMITED: 'RATE_LIMITED',
	REPORT_ALREADY_RESOLVED: 'REPORT_ALREADY_RESOLVED',
	REPORT_BANNED: 'REPORT_BANNED',
	REPORT_FLOW_OUTDATED: 'REPORT_FLOW_OUTDATED',
	REPORT_UNDER_LEGAL_HOLD: 'REPORT_UNDER_LEGAL_HOLD',
	RESPONSE_VALIDATION_ERROR: 'RESPONSE_VALIDATION_ERROR',
	RESOURCE_LOCKED: 'RESOURCE_LOCKED',
	SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
	SESSION_TOKEN_MISMATCH: 'SESSION_TOKEN_MISMATCH',
	SINGLE_COMMUNITY_CANNOT_CREATE_GUILDS: 'SINGLE_COMMUNITY_CANNOT_CREATE_GUILDS',
	SINGLE_COMMUNITY_CANNOT_DELETE: 'SINGLE_COMMUNITY_CANNOT_DELETE',
	SINGLE_COMMUNITY_CANNOT_LEAVE: 'SINGLE_COMMUNITY_CANNOT_LEAVE',
	INSTANCE_POLICY_TRANSITION_NOT_ALLOWED: 'INSTANCE_POLICY_TRANSITION_NOT_ALLOWED',
	SLOWMODE_RATE_LIMITED: 'SLOWMODE_RATE_LIMITED',
	SEARCH_INDEX_NOT_READY: 'SEARCH_INDEX_NOT_READY',
	SSO_REQUIRED: 'SSO_REQUIRED',
	STORE_BILLING_UNAVAILABLE: 'STORE_BILLING_UNAVAILABLE',
	STORE_NOTIFICATION_UNAUTHORIZED: 'STORE_NOTIFICATION_UNAUTHORIZED',
	STORE_PURCHASE_INVALID: 'STORE_PURCHASE_INVALID',
	STORE_PURCHASE_OWNED_BY_OTHER_ACCOUNT: 'STORE_PURCHASE_OWNED_BY_OTHER_ACCOUNT',
	STORE_PURCHASE_SANDBOX_NOT_ENTITLED: 'STORE_PURCHASE_SANDBOX_NOT_ENTITLED',
	STREAM_KEY_CHANNEL_MISMATCH: 'STREAM_KEY_CHANNEL_MISMATCH',
	STREAM_KEY_SCOPE_MISMATCH: 'STREAM_KEY_SCOPE_MISMATCH',
	STRIPE_ERROR: 'STRIPE_ERROR',
	STRIPE_GIFT_REDEMPTION_IN_PROGRESS: 'STRIPE_GIFT_REDEMPTION_IN_PROGRESS',
	STRIPE_INVALID_PRODUCT: 'STRIPE_INVALID_PRODUCT',
	STRIPE_INVALID_PRODUCT_CONFIGURATION: 'STRIPE_INVALID_PRODUCT_CONFIGURATION',
	STRIPE_NO_ACTIVE_SUBSCRIPTION: 'STRIPE_NO_ACTIVE_SUBSCRIPTION',
	STRIPE_NO_PURCHASE_HISTORY: 'STRIPE_NO_PURCHASE_HISTORY',
	STRIPE_REFUND_OUTSIDE_WINDOW: 'STRIPE_REFUND_OUTSIDE_WINDOW',
	STRIPE_REFUND_COOLDOWN_ACTIVE: 'STRIPE_REFUND_COOLDOWN_ACTIVE',
	STRIPE_NO_SUBSCRIPTION: 'STRIPE_NO_SUBSCRIPTION',
	STRIPE_PAYMENT_NOT_AVAILABLE: 'STRIPE_PAYMENT_NOT_AVAILABLE',
	STRIPE_SUBSCRIPTION_ALREADY_CANCELING: 'STRIPE_SUBSCRIPTION_ALREADY_CANCELING',
	STRIPE_SUBSCRIPTION_NOT_CANCELING: 'STRIPE_SUBSCRIPTION_NOT_CANCELING',
	STRIPE_WEBHOOK_NOT_AVAILABLE: 'STRIPE_WEBHOOK_NOT_AVAILABLE',
	STRIPE_WEBHOOK_SIGNATURE_INVALID: 'STRIPE_WEBHOOK_SIGNATURE_INVALID',
	STRIPE_WEBHOOK_SIGNATURE_MISSING: 'STRIPE_WEBHOOK_SIGNATURE_MISSING',
	DIRECT_MESSAGES_DISABLED: 'DIRECT_MESSAGES_DISABLED',
	NEW_CONVERSATIONS_LIMITED: 'NEW_CONVERSATIONS_LIMITED',
	DONATION_AMOUNT_INVALID: 'DONATION_AMOUNT_INVALID',
	DONATION_MAGIC_LINK_EXPIRED: 'DONATION_MAGIC_LINK_EXPIRED',
	DONATION_MAGIC_LINK_INVALID: 'DONATION_MAGIC_LINK_INVALID',
	DONATION_MAGIC_LINK_USED: 'DONATION_MAGIC_LINK_USED',
	SUDO_MODE_REQUIRED: 'SUDO_MODE_REQUIRED',
	TAG_ALREADY_TAKEN: 'TAG_ALREADY_TAKEN',
	TEMPORARY_INVITE_REQUIRES_PRESENCE: 'TEMPORARY_INVITE_REQUIRES_PRESENCE',
	TEST_HARNESS_DISABLED: 'TEST_HARNESS_DISABLED',
	TEST_HARNESS_FORBIDDEN: 'TEST_HARNESS_FORBIDDEN',
	THREAD_ALREADY_CREATED_FOR_MESSAGE: 'THREAD_ALREADY_CREATED_FOR_MESSAGE',
	THREAD_ARCHIVED: 'THREAD_ARCHIVED',
	THREAD_LOCKED: 'THREAD_LOCKED',
	TWO_FA_NOT_ENABLED: 'TWO_FA_NOT_ENABLED',
	TWO_FACTOR_REQUIRED: 'TWO_FACTOR_REQUIRED',
	UNAUTHORIZED: 'UNAUTHORIZED',
	UNCLAIMED_ACCOUNT_CANNOT_ACCEPT_FRIEND_REQUESTS: 'UNCLAIMED_ACCOUNT_CANNOT_ACCEPT_FRIEND_REQUESTS',
	UNCLAIMED_ACCOUNT_CANNOT_ADD_REACTIONS: 'UNCLAIMED_ACCOUNT_CANNOT_ADD_REACTIONS',
	UNCLAIMED_ACCOUNT_CANNOT_CREATE_APPLICATIONS: 'UNCLAIMED_ACCOUNT_CANNOT_CREATE_APPLICATIONS',
	UNCLAIMED_ACCOUNT_CANNOT_CREATE_GUILDS: 'UNCLAIMED_ACCOUNT_CANNOT_CREATE_GUILDS',
	UNCLAIMED_ACCOUNT_CANNOT_JOIN_GROUP_DMS: 'UNCLAIMED_ACCOUNT_CANNOT_JOIN_GROUP_DMS',
	UNCLAIMED_ACCOUNT_CANNOT_JOIN_ONE_ON_ONE_VOICE_CALLS: 'UNCLAIMED_ACCOUNT_CANNOT_JOIN_ONE_ON_ONE_VOICE_CALLS',
	UNCLAIMED_ACCOUNT_CANNOT_JOIN_VOICE_CHANNELS: 'UNCLAIMED_ACCOUNT_CANNOT_JOIN_VOICE_CHANNELS',
	UNCLAIMED_ACCOUNT_CANNOT_MAKE_PURCHASES: 'UNCLAIMED_ACCOUNT_CANNOT_MAKE_PURCHASES',
	UNCLAIMED_ACCOUNT_CANNOT_SEND_DIRECT_MESSAGES: 'UNCLAIMED_ACCOUNT_CANNOT_SEND_DIRECT_MESSAGES',
	UNCLAIMED_ACCOUNT_CANNOT_SEND_FRIEND_REQUESTS: 'UNCLAIMED_ACCOUNT_CANNOT_SEND_FRIEND_REQUESTS',
	UNCLAIMED_ACCOUNT_CANNOT_SEND_MESSAGES: 'UNCLAIMED_ACCOUNT_CANNOT_SEND_MESSAGES',
	UNCLAIMED_ACCOUNT_CANNOT_SUBMIT_REPORTS: 'UNCLAIMED_ACCOUNT_CANNOT_SUBMIT_REPORTS',
	UNKNOWN_CHANNEL: 'UNKNOWN_CHANNEL',
	UNKNOWN_EMOJI: 'UNKNOWN_EMOJI',
	UNKNOWN_FAVORITE_MEME: 'UNKNOWN_FAVORITE_MEME',
	UNKNOWN_FORUM_TAG: 'UNKNOWN_FORUM_TAG',
	UNKNOWN_GIFT_CODE: 'UNKNOWN_GIFT_CODE',
	UNKNOWN_GUILD: 'UNKNOWN_GUILD',
	UNKNOWN_HARVEST: 'UNKNOWN_HARVEST',
	UNKNOWN_INVITE: 'UNKNOWN_INVITE',
	UNKNOWN_MEMBER: 'UNKNOWN_MEMBER',
	UNKNOWN_MESSAGE: 'UNKNOWN_MESSAGE',
	UNKNOWN_ORIGIN_HANDOFF: 'UNKNOWN_ORIGIN_HANDOFF',
	UNKNOWN_PASSKEY_BRIDGE: 'UNKNOWN_PASSKEY_BRIDGE',
	UNKNOWN_PASSKEY_MIGRATION: 'UNKNOWN_PASSKEY_MIGRATION',
	UNKNOWN_REPORT: 'UNKNOWN_REPORT',
	UNKNOWN_ROLE: 'UNKNOWN_ROLE',
	UNKNOWN_STICKER: 'UNKNOWN_STICKER',
	UNKNOWN_STORE_PURCHASE: 'UNKNOWN_STORE_PURCHASE',
	UNKNOWN_THREAD_MEMBER: 'UNKNOWN_THREAD_MEMBER',
	UNKNOWN_USER_FLAG: 'UNKNOWN_USER_FLAG',
	UNKNOWN_USER: 'UNKNOWN_USER',
	UNKNOWN_VOICE_REGION: 'UNKNOWN_VOICE_REGION',
	UNKNOWN_VOICE_SERVER: 'UNKNOWN_VOICE_SERVER',
	UNKNOWN_WEBAUTHN_CREDENTIAL: 'UNKNOWN_WEBAUTHN_CREDENTIAL',
	UNKNOWN_APPLICATION: 'UNKNOWN_APPLICATION',
	UNKNOWN_WEBHOOK: 'UNKNOWN_WEBHOOK',
	WEBHOOK_FORUM_TARGET_CONFLICT: 'WEBHOOK_FORUM_TARGET_CONFLICT',
	WEBHOOK_FORUM_TARGET_REQUIRED: 'WEBHOOK_FORUM_TARGET_REQUIRED',
	WEBHOOK_SERVICE_FORUM_UNSUPPORTED: 'WEBHOOK_SERVICE_FORUM_UNSUPPORTED',
	WEBHOOK_THREAD_NAME_REQUIRES_FORUM: 'WEBHOOK_THREAD_NAME_REQUIRES_FORUM',
	USERNAME_NOT_AVAILABLE: 'USERNAME_NOT_AVAILABLE',
	USERNAME_SIGN_IN_ONLY: 'USERNAME_SIGN_IN_ONLY',
	UPDATE_FAILED: 'UPDATE_FAILED',
	USER_BANNED_FROM_GUILD: 'USER_BANNED_FROM_GUILD',
	USER_IP_BANNED_FROM_GUILD: 'USER_IP_BANNED_FROM_GUILD',
	USER_NOT_IN_VOICE: 'USER_NOT_IN_VOICE',
	USER_OWNS_GUILDS: 'USER_OWNS_GUILDS',
	VALIDATION_ERROR: 'VALIDATION_ERROR',
	VOICE_CHANNEL_FULL: 'VOICE_CHANNEL_FULL',
	WEBAUTHN_CREDENTIAL_LIMIT_REACHED: 'WEBAUTHN_CREDENTIAL_LIMIT_REACHED',
	AGE_VERIFICATION_ALREADY_VERIFIED: 'AGE_VERIFICATION_ALREADY_VERIFIED',
} as const;

export type APIErrorCode = ValueOf<typeof APIErrorCodes>;
